import { useState, useCallback, useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { fileDownload } from 'utils';
import { toast } from 'react-toastify';
import api from 'client';

export default (sessionToken, sessionId, files) => {
  const queryClient = useQueryClient();
  const [appointmentId, setAppointmentId] = useState(null);
  const [accessCode, setAccessCode] = useState(null);
  const [appointmentFiles, setAppointmentFiles] = useState(files);
  const getVideoSessionTokens = useCallback(
    ({ appointmentId: appointmentIdVal, accessCode: accessCodeVal }) =>
      api
        .post('/apis/v2/direct_video_session_tokens', { appointmentId: appointmentIdVal, accessCode: accessCodeVal })
        .then((data) => ({ adracareSessionToken: data?.data?.data?.id, ...data?.data?.data?.attributes }))
        .then((data) => {
          queryClient.setQueryData(['POST', '/apis/v2/direct_video_session_tokens', { appointmentId, accessCode }], data);
          setAppointmentId(appointmentIdVal);
          setAccessCode(accessCodeVal);
        }),
    [],
  );

  const { data } = useQuery(['POST', '/apis/v2/direct_video_session_tokens', { appointmentId, accessCode }], {
    enabled: !!appointmentId && !!accessCode,
    select: (responseData) => ({ adracareSessionToken: responseData?.data?.id, ...responseData?.data?.attributes }),
  });

  const participants = Object.values(data?.participants || {});

  const viewDocuments = () => {
    const config = {
      headers: { 'Adracare-Session-Token': sessionToken, 'Adracare-Session-Id': sessionId },
    };
    api.get(`/apis/v2/direct_video_session_tokens/view_documents`, config).then((response) => {
      if (response.status === 200) {
        if (response.data.data?.attributes?.attachments) {
          const documents = response.data.data?.attributes?.attachments.filter((item) => item.type !== 'questionnaire');
          setAppointmentFiles(documents);
        }
      }
    });
  };

  useEffect(() => {
    viewDocuments();
  }, []);

  const uploadDocument = async ({ attachments = [] }) => {
    const documentData = new FormData();
    const fileList = Array.from(attachments);
    if (fileList.length > 0) {
      fileList.forEach((file) => {
        documentData.append('files[]', file);
      });
    }
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Adracare-Session-Token': sessionToken,
        'Adracare-Session-Id': sessionId,
      },
    };

    return api
      .post(`/apis/v2/direct_video_session_tokens/upload_document`, documentData, config)
      .then(() => {
        viewDocuments();
      })
      .catch((err) => {
        toast.error(() => err.response?.data?.meta?.attachment || err.message);
      });
  };

  const downloadDocument = (attachmentId, attachmentName) => {
    const url = `/apis/v2/direct_video_session_tokens/download_document?key=${attachmentId}`;
    return api
      .get(url, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Adracare-Session-Token': sessionToken,
          'Adracare-Session-Id': sessionId,
        },
      })
      .then((response) => {
        fileDownload(response.data, attachmentName, { newWindow: true, mime: response.headers['content-type'] });
      })
      .catch((err) => {
        toast.error(() => err.response?.data?.message);
      });
  };

  return {
    videoSessionTokens: data,
    participants: participants || [],
    wherebyUrl: data?.wherebyUrl,
    getVideoSessionTokens,
    uploadDocument,
    downloadDocument,
    appointmentFiles,
  };
};
